import React from 'react'
import { H2, useContainerWidth } from '@fs/zion-ui'
import styles from './internal/RootsTechBannerTextStyles.module.css'

export default function RootsTechBannerHeading({ children, hasGradientText, ...props }) {
  const atSize = useContainerWidth()

  return (
    <H2 size={atSize({ default: 'H4', sm: 'H3' })} supplementary balanced {...props}>
      <span className={hasGradientText ? styles.magentaGradient : null}>{children}</span>
    </H2>
  )
}
